/* ==========================================================================
   FFL MAIN PRODUCT — Lovable-replica PDP JS (Session 17)
   Handles: gallery swap, zoom, calculator, qty controls, ATC fetch interception
   ========================================================================== */
(function () {
  'use strict';

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function init(root) {
    if (!root || root.__fflpInit) return;
    root.__fflpInit = true;

    var sqftPerBox = parseFloat(root.dataset.sqftPerBox) || 0;
    var ppsfCents = parseFloat(root.dataset.pricePerSqftCents) || 0;
    var ppbCents = parseFloat(root.dataset.pricePerBoxCents) || 0;
    var hasSqft = root.dataset.hasSqft === 'true';
    /* FFL CUSTOM (MAP 2026-09-18): show_price=0 means the price is hidden everywhere.
       The calculator still counts boxes and syncs the qty field, but never renders money. */
    var showPrice = root.dataset.showPrice !== '0';

    // ---- Gallery thumbnail swap ----
    var mainImg = root.querySelector('[data-fflp-main-img]');
    var thumbs = root.querySelectorAll('[data-fflp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          var fullUrl = thumb.dataset.fullUrl;
          var srcset = thumb.dataset.srcset;
          if (fullUrl) mainImg.src = fullUrl;
          if (srcset) mainImg.srcset = srcset;
        }
      });
    });

    // ---- Image zoom modal ----
    var zoomBtn = root.querySelector('[data-fflp-zoom-open]');
    var mainImgWrap = root.querySelector('.fflp__gallery-main');
    var zoomOverlay = root.querySelector('[data-fflp-zoom-overlay]');
    var zoomImg = root.querySelector('[data-fflp-zoom-img]');
    var zoomClose = root.querySelector('[data-fflp-zoom-close]');

    function openZoom(e) {
      if (e) e.stopPropagation();
      if (!zoomOverlay || !mainImg || !zoomImg) return;
      zoomImg.src = mainImg.src;
      zoomImg.alt = mainImg.alt || '';
      zoomOverlay.classList.add('is-open');
      zoomOverlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeZoom() {
      if (!zoomOverlay) return;
      zoomOverlay.classList.remove('is-open');
      zoomOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    if (zoomBtn) zoomBtn.addEventListener('click', openZoom);
    if (mainImgWrap) mainImgWrap.addEventListener('click', openZoom);
    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    if (zoomOverlay) zoomOverlay.addEventListener('click', function (e) {
      if (e.target === zoomOverlay) closeZoom();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && zoomOverlay && zoomOverlay.classList.contains('is-open')) closeZoom();
    });

    // ---- Coverage Calculator ----
    var sqftIn = root.querySelector('[data-fflp-sqft]');
    var boxesIn = root.querySelector('[data-fflp-boxes]');
    var overageSel = root.querySelector('[data-fflp-overage]');
    var totalsBox = root.querySelector('[data-fflp-totals]');
    var totalBoxesEl = root.querySelector('[data-fflp-total-boxes]');
    var totalPriceEl = root.querySelector('[data-fflp-total-price]');
    var qtyInput = root.querySelector('[data-fflp-qty]');

    function recalc(triggeredBy) {
      if (!hasSqft || sqftPerBox <= 0) return;
      var overagePct = parseFloat(overageSel ? overageSel.value : 10) || 0;
      var multiplier = 1 + (overagePct / 100);
      var sqft = parseFloat(sqftIn ? sqftIn.value : 0) || 0;
      var boxes = parseFloat(boxesIn ? boxesIn.value : 0) || 0;
      var totalBoxes = 0;
      var totalSqft = 0;

      if (triggeredBy === 'sqft' && sqft > 0) {
        if (boxesIn) boxesIn.value = '';
        totalSqft = sqft * multiplier;
        totalBoxes = Math.ceil(totalSqft / sqftPerBox);
      } else if (triggeredBy === 'boxes' && boxes > 0) {
        /* FFL CUSTOM (external audit item 14, 2026-09-20): a box count is an EXACT instruction.
           Multiplying it by the overage turned "I want 1 box" into 2 boxes. The overage belongs
           to the square-footage path only; entering boxes orders exactly that many. */
        if (sqftIn) sqftIn.value = '';
        totalBoxes = Math.ceil(boxes);
        totalSqft = totalBoxes * sqftPerBox;
      } else if (sqft > 0) {
        totalSqft = sqft * multiplier;
        totalBoxes = Math.ceil(totalSqft / sqftPerBox);
      } else if (boxes > 0) {
        totalBoxes = Math.ceil(boxes * multiplier);
        totalSqft = totalBoxes * sqftPerBox;
      }

      if (totalBoxes > 0) {
        if (totalsBox) totalsBox.hidden = false;
        if (totalBoxesEl) totalBoxesEl.textContent = totalBoxes + (totalBoxes === 1 ? ' box' : ' boxes');
        if (totalPriceEl) {
          totalPriceEl.textContent = showPrice
            ? moneyFormat(totalBoxes * ppbCents)
            : 'Calculated at checkout';
        }
        if (qtyInput) qtyInput.value = totalBoxes;
      } else {
        if (totalsBox) totalsBox.hidden = true;
        if (qtyInput) qtyInput.value = qtyInput.value < 1 ? 1 : qtyInput.value;
      }
    }
    if (sqftIn) sqftIn.addEventListener('input', function () { recalc('sqft'); });
    if (boxesIn) boxesIn.addEventListener('input', function () { recalc('boxes'); });
    if (overageSel) overageSel.addEventListener('change', function () { recalc(); });

    // ---- Quantity − / + buttons ----
    var minusBtn = root.querySelector('[data-fflp-qty-minus]');
    var plusBtn = root.querySelector('[data-fflp-qty-plus]');
    /* FFL CUSTOM (external audit item 02, 2026-09-20): ONE source of truth.
       The +/- buttons and direct typing used to change only the quantity field, leaving the
       calculator summary showing the old box count and total — the shopper could buy 2 boxes
       while reading "6 boxes, $530.46". Any quantity change now re-derives the summary from
       that quantity, so the summary, the quantity and the cart always agree. */
    function syncFromQuantity() {
      var q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (qtyInput) qtyInput.value = q;
      if (!hasSqft || sqftPerBox <= 0) return;
      // the quantity IS the box count: restate coverage and total from it, exactly
      if (boxesIn) boxesIn.value = '';
      if (sqftIn) sqftIn.value = '';
      if (totalsBox) totalsBox.hidden = false;
      if (totalBoxesEl) totalBoxesEl.textContent = q + (q === 1 ? ' box' : ' boxes');
      if (totalPriceEl) {
        totalPriceEl.textContent = showPrice ? moneyFormat(q * ppbCents) : 'Calculated at checkout';
      }
    }
    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
        syncFromQuantity();
      });
    }
    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
        syncFromQuantity();
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', syncFromQuantity);
      qtyInput.addEventListener('change', syncFromQuantity);
    }

    // ---- Add to Cart intercept (fetch /cart/add.js so upsell modal triggers) ----
    var form = root.querySelector('.fflp__form--atc');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atcBtn = root.querySelector('[data-fflp-atc]');
        if (atcBtn && atcBtn.disabled) return;
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.dataset.origText = atcBtn.textContent.trim();
          atcBtn.textContent = 'Adding…';
        }
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        }).then(function (r) {
          if (!r.ok) throw new Error('Cart add failed');
          return r.json();
        }).then(function (data) {
          if (atcBtn) {
            atcBtn.textContent = '✓ Added';
            setTimeout(function () {
              atcBtn.disabled = false;
              atcBtn.textContent = atcBtn.dataset.origText || 'Add to cart';
            }, 1500);
          }
          // Dispatch custom event so upsell-modal.js (existing) picks it up
          document.dispatchEvent(new CustomEvent('ffl:added-to-cart', { detail: data }));
          // Also dispatch Shopify's standard cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }).catch(function (err) {
          console.error('FFL ATC error:', err);
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = atcBtn.dataset.origText || 'Add to cart';
          }
          alert('Could not add to cart. Please try again or contact us.');
        });
      });
    }
  }

  function bootAll() {
    document.querySelectorAll('.fflp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
